import { createVueViewComponent } from "@/shared/utils/vue";



import { AllocationHistoryTableController } from "@/portal/controller/AllocationHistoryTableController";
import { ApiVersionController } from "@/portal/controller/ApiVersionController";
import { ApiVersionTableController } from "@/portal/controller/ApiVersionTableController";
import { ArticleController } from "@/portal/controller/ArticleController";
import { ArticleTableController } from "@/portal/controller/ArticleTableController";
import { AttributeController } from "@/portal/controller/AttributeController";
import { AttributeTableController } from "@/portal/controller/AttributeTableController";
import { CancellationTableController } from "@/portal/controller/CancellationTableController";
import { CombinationTableController } from "@/portal/controller/CombinationTableController";
import { DiscountController } from "@/portal/controller/DiscountController";
import { DocumentController } from "@/portal/controller/DocumentController";
import { DocumentTableController } from "@/portal/controller/DocumentTableController";
import { EventTableController } from "@/portal/controller/EventTableController";
import { FeedbackTableController } from "@/portal/controller/FeedbackTableController";
import { FulfillmentGroupController } from "@/portal/controller/FulfillmentGroupController";
import { FulfillmentGroupTableController } from "@/portal/controller/FulfillmentGroupTableController";
import { IssueTableController } from "@/portal/controller/IssueTableController";
import { LocationController } from "@/portal/controller/LocationController";
import { LocationTableController } from "@/portal/controller/LocationTableController";
import { LoginController } from "@/portal/controller/LoginController";
import { OfferCategoryController } from "@/portal/controller/OfferCategoryController";
import { OfferCategoryTableController } from "@/portal/controller/OfferCategoryTableController";
import { OfferController } from "@/portal/controller/OfferController";
import { OfferScheduleController } from "@/portal/controller/OfferScheduleController";
import { OfferScheduleTableController } from "@/portal/controller/OfferScheduleTableController";
import { OfferTableController } from "@/portal/controller/OfferTableController";
import { OptionGroupController } from "@/portal/controller/OptionGroupController";
import { OptionGroupTableController } from "@/portal/controller/OptionGroupTableController";
import { OrderApplicationController } from "@/portal/controller/OrderApplicationController";
import { OrderApplicationTableController } from "@/portal/controller/OrderApplicationTableController";
import { OrderController } from "@/portal/controller/OrderController";
import { OrderTableController } from "@/portal/controller/OrderTableController";
import { PayApplicationController } from "@/portal/controller/PayApplicationController";
import { PayApplicationTableController } from "@/portal/controller/PayApplicationTableController";
import { ProductionSiteController } from "@/portal/controller/ProductionSiteController";
import { ProductionSiteTableController } from "@/portal/controller/ProductionSiteTableController";
import { ReportCategoryController } from "@/portal/controller/ReportCategoryController";
import { ReportCategoryTableController } from "@/portal/controller/ReportCategoryTableController";
import { RoomController } from "@/portal/controller/RoomController";
import { RoomTableController } from "@/portal/controller/RoomTableController";
import { SaleInquiryTableController } from "@/portal/controller/SaleInquiryTableController";
import { ShiftTableController } from "@/portal/controller/ShiftTableController";
import { StockController } from "@/portal/controller/StockController";
import { SubscriptionController } from "@/portal/controller/SubscriptionController";
import { SubscriptionTableController } from "@/portal/controller/SubscriptionTableController";
import { SystemController } from "@/portal/controller/SystemController";
import { TableController } from "@/portal/controller/TableController";
import { TableTableController } from "@/portal/controller/TableTableController";
import { TaskController } from "@/portal/controller/TaskController";
import { TaskTableController } from "@/portal/controller/TaskTableController";
import { TransactionTableController } from "@/portal/controller/TransactionTableController";
import { UserController } from "@/portal/controller/UserController";
import { UserTableController } from "@/portal/controller/UserTableController";
import { UtilController } from "@/portal/controller/UtilController";
import { VoucherController } from "@/portal/controller/VoucherController";
import { VoucherTableController } from "@/portal/controller/VoucherTableController";
import { SignupController } from "@/portal/controller/signup/SignupController";
import DashboardView from "@/portal/views/DashboardView.vue";
import DiscountsListView from "@/portal/views/DiscountsListView.vue";
import TableCombinationsListView from "@/portal/views/TableCombinationsListView.vue";



// import css
import "./../../assets/styles/scss/portal.scss";
import "./../../assets/styles/scss/primevue/themes/saga/saga-green/theme.scss";
// import Portal
import { Portal } from "./Portal";


// register here every entry point that should be accessible from the outside - in document.ready function
const portalEntryPoints = {
    AllocationHistoryTableController,
    ApiVersionController,
    ApiVersionTableController,
    ArticleController,
    ArticleTableController,
    AttributeController,
    AttributeTableController,
    CancellationTableController,
    CombinationTableController,
    DiscountController,
    DocumentController,
    DocumentTableController,
    EventTableController,
    FeedbackTableController,
    FulfillmentGroupController,
    FulfillmentGroupTableController,
    IssueTableController,
    LocationController,
    LocationTableController,
    LoginController,
    OfferCategoryController,
    OfferCategoryTableController,
    OfferController,
    OfferScheduleController,
    OfferScheduleTableController,
    OfferTableController,
    OptionGroupController,
    OptionGroupTableController,
    OrderController,
    OrderTableController,
    PayApplicationController,
    PayApplicationTableController,
    ProductionSiteController,
    ProductionSiteTableController,
    ReportCategoryController,
    ReportCategoryTableController,
    RoomController,
    RoomTableController,
    SaleInquiryTableController,
    ShiftTableController,
    SignupController,
    StockController,
    SubscriptionController,
    SubscriptionTableController,
    SystemController,
    TableController,
    TableTableController,
    TaskController,
    TaskTableController,
    TransactionTableController,
    OrderApplicationController,
    OrderApplicationTableController,
    UserController,
    UserTableController,
    UtilController,
    VoucherTableController,
    VoucherController,
};
(window as any).TastierModuleControllers = portalEntryPoints;

(window as any).TastierViews = {
    initDashboardView: ($element: JQuery) => createVueViewComponent(DashboardView, {}, $element[0]),
    initDiscountsListView: ($element: JQuery) => createVueViewComponent(DiscountsListView, {}, $element[0]),
    initCombinationListview: ($element: JQuery) => createVueViewComponent(TableCombinationsListView, {}, $element[0]),
};

Portal.init();
